<template>
  <div class="list">
    <div class="item" v-for="item in listData">
      <div class="header">
        <img class="icon" src="@/assets/images/market-service-hk.png" v-if="item.packageMarket === 'HK'" :alt="item.packageName"/>
        <img class="icon" src="@/assets/images/market-service-us.png" v-if="item.packageMarket === 'US'" :alt="item.packageName"/>
        <p class="title">{{ item.packageName }}</p>
      </div>
      <div class="content">

        <p class="sub">
          <span>生效日期：</span>
          <span v-if="item.startingDate">{{ item.startingDate.substring(0,11) }}</span>
        </p>
        <p class="sub">
          <span>到期日期：</span>
          <span v-if="item.expiryDate">{{ item.expiryDate.substring(0,11) }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    listData: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="less" scoped>
.list {
  overflow: hidden;

  .item {
    border-bottom: #f3f3f3 solid 1px;
    padding: 32px 0 40px;

    .header {
      display: flex;
      align-items: center;
      .icon{
        display: block;
        width: 50px;
        height: 50px;
        margin-right: 20px;
      }
      .title {
        margin-top: 5px;
        font-size: 32px;
        font-weight: 500;
        line-height: 44px;
      }
    }

    .content {
      margin-top: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .sub{
        font-size: 24px;
        line-height: 30px;
        color: #A2A2A2;
      }
    }
  }
}
.black-theme{
  .list {
    .item{
      border-color: #323442;
    }
  }
}
</style>
